
import React from 'react';
import { Message } from '@/types/reportTypes';

interface ChatMessagesProps {
  messages: Message[];
  isLoading: boolean;
}

export const ChatMessages = ({ messages, isLoading }: ChatMessagesProps) => {
  return (
    <>
      {messages.map((message) => (
        <div 
          key={message.id}
          className={`mb-4 p-3 rounded-lg max-w-[85%] ${
            message.role === 'assistant' 
              ? 'bg-muted text-foreground mr-auto' 
              : 'bg-primary text-primary-foreground ml-auto'
          }`}
        >
          <div className="whitespace-pre-wrap">{message.content}</div>
          <div className="text-xs opacity-70 mt-1">
            {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
      ))}
      {isLoading && (
        <div className="mb-4 p-3 rounded-lg bg-muted text-foreground mr-auto max-w-[85%]">
          <div className="flex space-x-2 items-center">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      )}
    </>
  );
};
